import React from 'react'
import { Action } from 'redux'
import { ToastTypes } from '../../containers/Toast'
import { ToastAction } from '../../reducers/toasts/actionNames'
import fireToastError from './fireToastError'
import fireToastInfo from './fireToastInfo'
import fireToastSuccess from './fireToastSucces'
import fireToastWarning from './fireToastWarning'

const fireToast = (
  toastType: ToastTypes,
  message: string | React.ReactNode,
  delayClose: number | false = 5000,
  container = 'Main',
  toastId: string | number = undefined,
  withButton = false,
  buttonLabel = '',
  buttonCb: () => void = null,
  buttonIcon: any = null,
): IToast => {
  switch (toastType) {
    case ToastTypes.Success:
      return fireToastSuccess(
        message,
        delayClose,
        container,
        toastId ? toastId : (message as string),
        withButton,
        buttonLabel,
        buttonCb,
        buttonIcon,
      )
    case ToastTypes.Info:
      return fireToastInfo(
        message,
        delayClose,
        container,
        toastId ? toastId : (message as string),
        withButton,
        buttonLabel,
        buttonCb,
        buttonIcon,
      )
    case ToastTypes.Warning:
      return fireToastWarning(
        message,
        delayClose,
        container,
        toastId ? toastId : (message as string),
        withButton,
        buttonLabel,
        buttonCb,
        buttonIcon,
      )
    case ToastTypes.Error:
      return fireToastError(
        message,
        delayClose,
        container,
        toastId ? toastId : (message as string),
        withButton,
        buttonLabel,
        buttonCb,
        buttonIcon,
      )
  }

  return fireToastInfo(
    message,
    delayClose,
    container,
    toastId ? toastId : (message as string),
    withButton,
    buttonLabel,
    buttonCb,
    buttonIcon,
  )
}

export default fireToast
export {
  ToastTypes,
  fireToastSuccess,
  fireToastError,
  fireToastWarning,
  fireToastInfo,
}

export interface IToast<T = ToastAction> extends Action<T> {
  message: string | React.ReactNode
  delayClose: number | false
  container: string
  toastId: string | number
}
